import React from "react";

const SpreadsheetRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.00001 5.05005C2.69626 5.05005 2.45001 5.29629 2.45001 5.60005C2.45001 5.90381 2.69626 6.15005 3.00001 6.15005H8.50001C8.80377 6.15005 9.05001 5.90381 9.05001 5.60005C9.05001 5.29629 8.80377 5.05005 8.50001 5.05005H3.00001ZM11.5 5.05005C11.1963 5.05005 10.95 5.29629 10.95 5.60005C10.95 5.90381 11.1963 6.15005 11.5 6.15005H17C17.3038 6.15005 17.55 5.90381 17.55 5.60005C17.55 5.29629 17.3038 5.05005 17 5.05005H11.5ZM2.45001 10.1C2.45001 9.79629 2.69626 9.55005 3.00001 9.55005H8.50001C8.80377 9.55005 9.05001 9.79629 9.05001 10.1C9.05001 10.4038 8.80377 10.65 8.50001 10.65H3.00001C2.69626 10.65 2.45001 10.4038 2.45001 10.1ZM11.5 9.55005C11.1963 9.55005 10.95 9.79629 10.95 10.1C10.95 10.4038 11.1963 10.65 11.5 10.65H17C17.3038 10.65 17.55 10.4038 17.55 10.1C17.55 9.79629 17.3038 9.55005 17 9.55005H11.5ZM2.45001 14.35C2.45001 14.0463 2.69626 13.8 3.00001 13.8H8.50001C8.80377 13.8 9.05001 14.0463 9.05001 14.35C9.05001 14.6538 8.80377 14.9 8.50001 14.9H3.00001C2.69626 14.9 2.45001 14.6538 2.45001 14.35ZM11.5 13.8C11.1963 13.8 10.95 14.0463 10.95 14.35C10.95 14.6538 11.1963 14.9 11.5 14.9H17C17.3038 14.9 17.55 14.6538 17.55 14.35C17.55 14.0463 17.3038 13.8 17 13.8H11.5Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SpreadsheetRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;